<template>
    <div>
        <div v-if="show_form == false">
            <b-tabs id="tabs" justified nav-class="nav-tabs-custom" content-class="text-muted">
                <b-tab active>
                    <template v-slot:title>
                        <span class="d-inline-block d-sm-none">
                            <i class="fas fa-home"></i>
                        </span>
                        <span class="d-none d-sm-inline-block">Configuration</span>
                    </template>
                    <div class="tabBody">
                        <!--//* WIZARD for linking supplier to location -->
                            <form-wizard shape="tab" ref="step-wizard" @on-change="onChange" @on-complete="onComplete" color="#15bf48">
                                <tab-content lazy :before-change="tabChange" :icon="`mdi mdi-numeric-1-box-multiple`">
                                    <h1>Locations Table</h1>
                                    <b-row>
                                        <b-col cols="9">
                                            <Locations />
                                        </b-col>
                                        <b-col cols="3">
                                            <LocationForm
                                                class="p-2"
                                                style="border: 1px solid lightgrey;"
                                                :types="locationTypes"/>
                                        </b-col>
                                    </b-row>
                                </tab-content>

                                <tab-content lazy :before-change="tabChange" :icon="`mdi mdi-numeric-2-box-multiple`">
                                    <h1>Suppliers Table</h1>
                                    <b-row>
                                        <b-col cols="9">
                                            <Suppliers />
                                        </b-col>
                                        <b-col cols="3">
                                            <SupplierForm class="p-2" style="border: 1px solid lightgrey;" />
                                        </b-col>
                                    </b-row>
                                </tab-content>

                                <tab-content :lazy="true" :before-change="tabChange" :icon="`mdi mdi-numeric-3-box-multiple`">
                                    <h1>Linking Table</h1>
                                    <b-row>
                                        <b-col cols="12">
                                            <LinkingTable />
                                        </b-col>
                                    </b-row>
                                </tab-content>
                            
                            </form-wizard>
                            
                            <div class="pt-2 mb-2">
                                <b-button variant="outline-secondary" @click="navigateBack" v-if="current_view != 'locations'" ><i class="fas fa-arrow-left"></i></b-button>
                                &nbsp;
                                
                                <b-button variant="primary" v-if="current_view == 'location_suppliers'" @click="showForm('suppliers')">Add Supplier</b-button>
                                <!--<b-button variant="primary" v-if="current_view == 'sla'">Add SLA</b-button> -->
                                
                            </div>

                            <!--<div class="" v-if="current_view == 'locations'">
                                <Locations />
                            </div>
                            <div class="" v-if="current_view == 'location_suppliers'">
                                <Suppliers />
                            </div>-->
                            <!--<div class="" v-if="current_view == 'sla'">
                                <SLA />
                            </div>-->
                    </div>
                </b-tab>

                <b-tab>
                    <template v-slot:title>
                        <span class="d-inline-block d-sm-none">
                            <i class="fas fa-home"></i>
                        </span>
                        <span class="d-none d-sm-inline-block">Site Plan</span>
                    </template>
                    <div class="tabBody">
                        <form-plugin 
                        class="mt-2"
                            :viewFile="clientMediaFile(step.spreadify_uid)"
                            :step="step_data.render_order"
                            @hasLoaded="has_form_loaded = true"
                            @downloadFile=processFileDownload
                            @uploaderData="processUpload"
                            @formDataUpdated="updateFormData"
                            :viewData="step.form_data"
                            :uid="step.spreadify_uid"></form-plugin>
                    </div>
                </b-tab>
            </b-tabs>
        </div>
        <div v-else>
            <b-button variant="outline-secondary" @click="show_form = false; current_view = previous_view"><i class="fas fa-arrow-left"></i></b-button>
            &nbsp;
            <!--<span>
                <h4 style="width: 50%;" v-if="current_view == 'location_form'">Location Form</h4>
                <h4 style="width: 50%;" v-if="current_view == 'supplier_form'">Supplier Form</h4>
            </span>-->

            <!--<div v-if="current_view == 'location_form'">
                <LocationForm :types="locationTypes" />
            </div>-->
            <!--<div v-if="current_view == 'supplier_form'">
               
            </div>-->
        </div>
    </div>
</template>

<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import Uploader from 'simple-uploader.js'
import { licenseAppState, licenseAppMethods, facilityAdminMethods, facilityAdminState } from '@/state/helpers'
import Locations from '../pre-inspection/sitePlansConfig/locationsTable.vue'
import Suppliers from '../pre-inspection/sitePlansConfig/locationSuppliersTable.vue'
import LinkingTable from '../pre-inspection/sitePlansConfig/linkingTable.vue'
//import SLA from '../pre-inspection/sitePlansConfig/locationSLA.vue'

import LocationForm from '../pre-inspection/sitePlansConfig/addLocationForm.vue'
import SupplierForm from '../pre-inspection/sitePlansConfig/addSupplierForm.vue'
export default {
    components:{
        Locations,
        Suppliers,
        LinkingTable,
        //SLA,
        LocationForm,
        SupplierForm,
        FormWizard,
        TabContent,
    },
    data:() => ({
        show_form: false,
        previous_view: '',
        current_view: 'locations', // locations - location_suppliers - sla
        selected_location: null,
        selected_supplier: null,

        has_form_loaded: false,
        current_form_data: [],
    
    }),
    computed:{
        ...facilityAdminState,
        ...licenseAppState,
        step(){
            if(this.step_data != null){
                return this.step_data.spreadify_views[0];
            }
            else{
                return {};
            }
        },
        step_uid(){
            return this.step.spreadify_uid;
        },
        locationTypes(){
            let types = [];
            if(this.location_types != null){
                types = this.location_types;
            }
            return types;
        }

    },
    methods:{
        ...facilityAdminMethods,
        ...licenseAppMethods,
        navigateBack(){
            if(this.current_view == 'sla'){
                this.current_view = 'location_suppliers'
            }
            else if(this.current_view == 'location_suppliers'){
                this.current_view = 'locations'
                this.selected_supplier = null;
            }
        },

        processUpload(file){
            //* Uploader event method
            let storage = window.localStorage;
            let AUTH_TOKEN = storage.getItem('x_token');
            let uploader = new Uploader({
                target: process.env.VUE_APP_API_BASEURL + 'api/licenseapp/uploadmedia',
                headers: {
                    'Authorization': 'Bearer ' + AUTH_TOKEN,
                },
                query:{/* '612f6171f003b',*/
                    step_id : this.step_data.id,
                    spreadify_uid : this.step_uid,
                    key : 'document_file',
                },
                testChunks: false,
                fileParameterName: 'file', //Set the upload post param which will contain the binary payload
                singleFile: false, //Limit upload to one file
            });
            //eslint-disable-next-line
            uploader.on('fileComplete', function (rootFile) {
                this.$swal.fire({ toast: true, position: 'top', iconColor: 'white', icon: 'success', title:'File Uploaded', customClass: {     popup: 'success-toast' }, showConfirmButton: false, timer: 2000, timerProgressBar: true});
            });
            //eslint-disable-next-line
            uploader.on('fileAdded', function (file, event) {
                console.log('fileAdded', file);
            });

            this.$nextTick(()=>{
                if(file.length == undefined){
                    uploader.addFile(file);
                    this.$nextTick(()=>{
                        uploader.upload();
                    });
                }
                else if(file.length){
                    for(let i = 0; i < file.length; i++ ){
                        uploader.addFile(file[i]);
                    }
                    this.$nextTick(()=>{
                        uploader.upload();
                    });
                }
            });
        },
        processFileDownload(params){
            this.showDownloadModal = true;
            this.$nextTick(()=>{
                this.$bvModal.show('downloadModal');
                this.$root.$once('bv::modal::hidden',(event)=>{
                    if(event.type == 'hidden' && event.componentId == 'downloadModal'){
                        this.showDownloadModal = false;
                    }
                })
                this.getDownloadLink(params)
                .then(response => {
                    this.$eventHub.$emit('setDownloadUrl', response);
                })
            })
        },
        updateFormData(newData){
            this.current_form_data = newData.data;
        },
        clientMediaFile(uid){
            let files = [];
            this.step_data.client_uploads.forEach((file) => {
                if(file.spreadify_uid == uid){
                    files.push(file);
                }
            });
            return files;
        },
        save(){
            this.$emit('back', this.step_data.id);
        },


        showForm(type){
            this.show_form = true;
            this.previous_view = this.current_view;
            if(type == 'locations'){
                this.current_view = 'location_form'
            }
            else if(type == 'suppliers'){
                this.current_view = 'supplier_form'
            }
        },


        /* Wizard plugin methods */
        tabChange(){
            //* Maybe check if locations and suppliers has any data before moving to the final step
            return true;
        },
        //eslint-disable-next-line
        onChange(previous, next){
            //* Refresh webix tables that get rendered while not visible
            let table = null
            this.$nextTick(()=>{
                if(next == 2){
                    //* ID 2 has 2 tables
                    // eslint-disable-next-line
                    let t1 = $$('locationsLinkingTable');
                    // eslint-disable-next-line
                    let t2 = $$('suppliersLinkingTable');

                    t1.refresh();
                    t2.refresh();
                }
                else{
                    if(next == 0){
                        // eslint-disable-next-line
                        table = $$('locationsTable');
                    }
                    else if(next == 1){
                        // eslint-disable-next-line
                        table = $$('suppliersTable');
                    }

                    if(table != undefined){
                        table.refresh();
                    }
                }
                
            })
        },
        onComplete(){
            /*this.isSaving = true;
            this.params.form_data = this.params.form_data.filter(Boolean);

            this.saveFormData(this.params)
            .then(()=>{
                this.isSaving = false;
                this.requestStepApproval(this.step_data.id)
                .then(()=>{
                    this.$swal.fire({ toast: true, position: 'top', iconColor: 'white', icon: 'success', title:'Success', customClass: {     popup: 'success-toast' }, showConfirmButton: false, timer: 2000, timerProgressBar: true});
                    this.$emit('back', this.step_data.id);
                })
                .catch(()=>{ console.log('Error submitting final form')})
            })
            .catch(()=>{
                setTimeout(()=>{
                    this.isSaving = false;
                    alert('Approval Request Error');
                }, 500)
            })*/
        },
    },
    mounted(){
        this.$refs['step-wizard'].activateAll();

        //TODO only load if vuex value is null
        this.loadLocationTypes();
        this.loadClientLocations();
        this.loadClientSuppliers();

    },
}
</script>

<style>
</style>